import React, { Component } from 'react';
import { Layout, LoginForm } from 'components';
import { Container, device } from 'utils';
import styled from '@emotion/styled';
import ContactModal from 'scenes/Project/components/ContactModal';

const LoginWrapper = styled.div`
  max-width: 400px;
  margin: 100px auto;
  @media ${device.allMobile} {
    max-width: 100%;
  }
`;
export default class LoginPage extends Component {
  render() {
    return (
      <Layout>
        <ContactModal />

        <Container>
          <LoginWrapper>
            <LoginForm />
          </LoginWrapper>
        </Container>
      </Layout>
    );
  }
}
